import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@ui-elements/Button';
import { ButtonProps } from '@mui/material/Button';

type Props = {
  handleClick: ButtonProps['onClick'];
  label?: string;
  dataTestId?: string;
};

const SaveButton: React.FC<Props & ButtonProps> = ({
  handleClick,
  label,
  dataTestId,
  ...props
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      handleClick={handleClick}
      data-testid={dataTestId ? `uiElements-saveButton-${dataTestId}` : `uiElements-saveButton`}
      {...props}
    >
      <span>{label || t('appCommon.save')}</span>
    </Button>
  );
};

export default SaveButton;
